/**
 * Custom Javascript Code for Gutenberg Blocks.
 *
 * @author Eberhard Lauth
 *
 */
( function ( $ ) {

    
    /** 
     * Add Foundation and some helper classes to Gutenberg Blocks
     */
    
    /* Columns Block */
    
    $('.wp-block-columns').addClass('grid-x grid-margin-x');
    $('.wp-block-columns .wp-block-column').addClass('cell large-auto');
    $('.wp-block-columns .wp-block-column .wp-block-columns .wp-block-column').removeClass('cell');
    $('.wp-block-columns.study-8-4 > .wp-block-column:first-child').addClass('medium-9 large-8');
    $('.wp-block-columns.study-8-4 > .wp-block-column:last-child').addClass('medium-3 large-4');
    
    /* Button Block */
    
    $('.wp-block-button a').addClass('button large');
    $('.wp-block-button.is-style-expanded a').addClass('expanded');
    
    /* Tables Block */
    $('.wp-block-table.is-style-stripes').addClass('striped');
    
    /* Alignfull fix for blocks */
    
    $('.content .alignfull').wrap( '<div class="alignfull-container" />');
    
    var container_width = $('.entry-content').width();
    var window_width = $( window ).width();
    var left_offset = (window_width - container_width)/2*-1;
    $('.alignfull-container').css('left', left_offset);
    
    $( window ).resize( function() {
        var container_width = $('.entry-content').width();
        var window_width = $( window ).width();
        var left_offset = (window_width - container_width)/2*-1;
        $('.alignfull-container').css('left', left_offset);
    } );
    
    /* Accordion for Yoast SEO strutctured data block FAQ */
    
    $('.wp-block-yoast-faq-block').addClass('accordion').attr('data-accordion','').attr('data-multi-expand','true').attr('data-allow-all-closed','true');
    $('.schema-faq-section').addClass('accordion-item').attr('data-accordion-item','');
    $('.schema-faq-question').wrap('<a href="#" class="accordion-title"></a>');
    $('.schema-faq-answer').addClass('accordion-content').attr('data-tab-content','');
    
} )( jQuery );